import { Stack, styled } from "@mui/material";

export const StackSidebarWatch = styled(Stack)(({ theme }) => ({
  "& > *:not(:last-child)": {
    borderBottom: `1px solid ${theme.customColors.border}`,
    marginBottom: "1.5rem",
    paddingBottom: "1.5rem"
  },
  "&:hover": {
    borderColor: theme.customColors.borderAccent
  },
  background: theme.customColors.backgroundPrimary,
  border: `0.0625rem solid ${theme.customColors.border}`,
  borderRadius: "1.125rem",
  color: theme.customColors.exploreCardText,
  display: "flex",
  flexDirection: "column",
  maxWidth: "24rem",
  padding: "1.5rem",
  transition: "all 0.2s ease",
  width: "24rem",
  [theme.breakpoints.down("lg")]: {
    maxWidth: "100%",
    minWidth: "15rem",
    width: "100%"
  }
}));
